// extracted by mini-css-extract-plugin
module.exports = {"main-sidebar-mobile-trigger":"style_main-sidebar-mobile-trigger__kFuzO"};